import React from "react";
import { observer } from "mobx-react";

import { BetOffer } from "@models";
import OfferItem from "./OfferItem";

export default observer(function OfferGroup(props: {
	offerGroup: BetOffer[];
	groupHasTitle: boolean;
	offersHaveColor: boolean;
	isPopup?: boolean;
}) {
	return (
		<>
			{props.offerGroup.map((offer) => {
				return (
					<OfferItem
						key={offer.id}
						offer={offer}
						groupHasTitle={props.groupHasTitle}
						offersHaveColor={props.offersHaveColor}
						isPopup={props.isPopup}
					/>
				);
			})}
		</>
	);
});
